import React from "react";

import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Flex,
  Container,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Button,
} from "@chakra-ui/react";
import AdminDataTable from "components/AdminDataTable/AdminDataTable";
import { AiOutlineSearch } from "react-icons/ai";
import { userAnalyticRequest } from "services/request";
import { QUERY_KEYS } from "utils/constants";
import dayjs from "dayjs";
import Paginator from "components/Paginator";
import { useQuery } from "react-query";
import axiosInstance from "services/httpService";

const VerifiedUsers = () => {
  const history = useNavigate();
  const [searchParams] = useSearchParams();
  const [pageSize, setPageSize] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(0);

  const makeAPICall = async ({ queryKey }) => {
    const page = queryKey[1];
    const size = queryKey[2];
    const url = userAnalyticRequest.USERS_ANALYTIC + `?q=verified&page=${page}&size=${size}`;
    const res = await axiosInstance.get(url);
    return res.data;
  };

  const { data: userDetails = {}, isLoading } = useQuery(
    [QUERY_KEYS.USER_ANALYTICS, currentPage, pageSize],
    makeAPICall,
  );

  const handlePageChange = (newPage: number) => {
    searchParams.set("page", String(newPage));
  };

  const handleSizeChange = (newSize) => {
    searchParams.set("size", String(newSize));
  };

  const { paginationMeta } = userDetails;
  const Users = userDetails.data;

  const COLUMNS = [
    {
      Header: "Name",
      accessor: "userName",
    },
    {
      Header: "Registered On",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>;
      },
    },
    {
      Header: "Last Updated",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
    },
  ];

  return (
    <Container mt="4" maxW="container.xl">
      <Flex justify={"space-between"} mt={"20px"} align="center">
        <Button
          variant="secondary"
          onClick={() => {
            history(-1);
          }}
        >
          Back
        </Button>

        <Text fontSize="20px" fontWeight="500">
          Verified Users
        </Text>

        <Box
          display={{
            base: "none",
            lg: "block",
            xl: "block",
          }}
        >
          <InputGroup>
            <InputRightElement pointerEvents="none">
              <AiOutlineSearch color="gray.300" />
            </InputRightElement>
            <Input rounded="full" type="text" placeholder="Search" bg="white" />
          </InputGroup>
        </Box>
      </Flex>

      <Box p={"0 10px"} mt="2">
        <AdminDataTable
          ariaLabel="Verified users"
          columns={COLUMNS}
          data={Users}
          loading={isLoading}
          showRowNumbers
          startIndex={pageSize * currentPage + 1}
        />
      </Box>
      <Paginator
        pageCount={paginationMeta?.totalPages}
        onPageChange={(page) => {
          setCurrentPage(Number(page.selected));
          handlePageChange(currentPage);
        }}
        pageNo={paginationMeta?.currentPage}
        pageSize={pageSize}
        onSizeChange={(selectedPage) => {
          setPageSize(Number(selectedPage));
          handleSizeChange(pageSize);
        }}
      />
    </Container>
  );
};

export default VerifiedUsers;
